(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SeasonDetailsController = (function(superClass) {
    extend(SeasonDetailsController, superClass);

    function SeasonDetailsController(scope, transitions, modal, http, service, state) {
      var alert_date;
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      SeasonDetailsController.__super__.constructor.apply(this, arguments);
      alert_date = moment(this.service.survey.growth_stage_last_updated).add(2, 'weeks');
      this.displayGrowthStageAlert = alert_date.isBefore();
      this.service.survey.growth_stage_last_updated = moment().format('YYYY-MM-DD HH:mm:ss');
    }

    return SeasonDetailsController;

  })(Controller);

}).call(this);
